import * as React from 'react';
import styles from './index.module.sass'

const BrowserSupport: React.FunctionComponent = () => {
  return (
    <>
    <div className={styles.blur}></div>
    <div className={styles.root}>
      <div className={styles.logo}></div>
        <div className={styles.wrapper}>
          <div className={styles.circle}>
            <div className={styles.inner}>
                <div className={styles.errorHeader}>
                  <p><b> to access this experience, </b></p>
                  <p>please use an up to date browser.</p>
                  <p>We recommend using...</p>
                </div>
                <div className={styles.browsers}>
                    <div className={styles.chrome}>
                      <img alt='rly' src='/descktopError/chrome.png'></img>
                      <p>chrome</p>
                    </div>
                    <div className={styles.border}>
                      <div className={styles.top}></div>
                      <p>or</p>
                      <div className={styles.bottom}></div>
                    </div>
                    <div className={styles.mozila}>
                      <img alt='rly' src='/descktopError/firefox.png'></img>
                      <p>mozila</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default BrowserSupport;
